import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

// feature component
@Component({
    selector: 'story-container',
    template: `
        <div [class]="classes()">
            <ng-content></ng-content>
        </div>
    `,
    imports: [CommonModule],
})
export class StoryContainerComponent {
    space = input<string>('pb-[40px] md:pb-[70px] lg:pb-[100px]');
    skipTopPadding = input<boolean>(false);
    skipSmallScreenTopPadding = input<boolean>(false);

    classes = computed(() => {
        const arr = [
            'mx-auto max-w-[1200px] pl-[max(24px,env(safe-area-inset-left))] pr-[max(24px,env(safe-area-inset-right))]',
        ];
        arr.push(this.space());
        if (!this.skipTopPadding()) {
            arr.push('pt-[40px] md:pt-[70px] lg:pt-[100px] ');
        }
        if (!this.skipSmallScreenTopPadding()) {
            arr.push('pt-[40px] ');
        }

        return arr.join(' ');
    });
}
